import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardGridRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('planning.dashboard.overview.grid');
  }
  model() {
    return this.modelFor('planning.dashboard');
  }
}

export default instrumentRoutePerformance(PlanningDashboardGridRoute);
